<app-module-header
  [title]="$safeNavigationMigration(orgName?.organizationName) + ' - ' + ('PLACEHOLDER.INTERNAL_BOOKING' | transloco)"
  [icon]="'book_online'"></app-module-header>

@if ((orgName?.organizationId?.toLowerCase() == '942ce067-7848-4441-b746-8f6eed7395bb')) {
<div class="container mt-3">
  <mat-slide-toggle class="mt-2" (change)="showQualityLongTermForm = $event.checked"
    [checked]="showQualityLongTermForm">
    {{ 'INTERNAL_BOOKING.USE_LONG_TERM_BOOKING' | transloco }} Quality
  </mat-slide-toggle>
  @if (showQualityLongTermForm) {
  <app-quality-internal-booking-form></app-quality-internal-booking-form>
  }
</div>
}

@if (!showQualityLongTermForm) {
<div class="container">
  <form [formGroup]="bookingForm">
    <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
      <mat-icon class="mr-3">business</mat-icon>{{ 'INTERNAL_BOOKING.ORGANIZATION'
      | transloco }}
    </mat-toolbar>
    <mat-form-field appearance="outline">
      <mat-label>{{'INTERNAL_BOOKING.CHOOSE_ORGANIZATION' | transloco }}</mat-label>
      <mat-select (selectionChange)="selectOrganization($event)" formControlName="organization">
        @for (item of allOrgs; track item) {
        <mat-option [value]="item">
          <div class="display-flex">
            <span class="font-weight-bold mr-2">
              {{item.name}}
            </span>
          </div>
        </mat-option>
        }
      </mat-select>
      @if (isLoadingOrganization) {
      <mat-spinner matSuffix color="accent" diameter="20">
      </mat-spinner>
      }
      @if (!isLoadingOrganization) {
      <mat-icon matSuffix>business</mat-icon>
      }
      @if (!bookingForm.controls?.organization?.valid &&
      bookingForm.controls?.organization?.touched) {
      <mat-error>
        {{'INTERNAL_BOOKING.PLEASE_SELECT_ORGANIZATION' | transloco }}
      </mat-error>
      }
    </mat-form-field>
    @if (bookingForm.get('organization')?.value?.name?.toLowerCase() === 'ving') {
    <mat-form-field appearance="outline">
      <mat-label>{{ 'PLACEHOLDER.TRAVEL_AGENT_BUNDLE' | transloco }}</mat-label>
      <mat-select (selectionChange)="getTravelAgencyBundle($event)" formControlName="travelAgency">
        @for (bundle of productOption; track bundle) {
        <mat-option [value]="bundle.value">
          <div class="display-flex">
            <span class="font-weight-bold mr-2">
              {{bundle.viewValue}}
            </span>
            <div class="spacer"></div>
            <span class="font-weight-light">
              {{bundle.price}} SEK
            </span>
          </div>
        </mat-option>
        }
      </mat-select>
      <mat-icon matSuffix>loyalty</mat-icon>
      @if (!bookingForm.controls.travelAgency.valid &&
      bookingForm.controls.travelAgency.touched) {
      <mat-error>
        {{ 'ERROR.SELECT_BUNDLE' | transloco }}
      </mat-error>
      }
    </mat-form-field>
    }
    <app-text-input [formControl]='bookingForm.controls["email"]' [type]="'email'" [label]="'Email'"
      [placeholder]="'PLACEHOLDER.EMAIL' | transloco" [icon]="'email'">
    </app-text-input>
    <!-- Subscription Selection -->
    @if (showSubscription) {
    <mat-slide-toggle class="mt-3" formControlName="subscription">
      Subscription
    </mat-slide-toggle>
    }
    <!--Departure-->
    <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
      @if(showSimpleBooking){
      <mat-icon class="mr-3">directions_car</mat-icon>{{ 'PARKIFLY.SIMPLE_SEARCH_SELECT.DEPARTURE_HEADING' |
      transloco }}
      }@else{
      <mat-icon class="mr-3">flight_takeoff</mat-icon>{{ 'PLACEHOLDER.DEPARTURE' | transloco }}
      }
    </mat-toolbar>
    <!-- Simple Booking: Date and Time Only -->
    @if (showSimpleBooking) {
    <div>
      <mat-form-field appearance="outline" (click)="simpleDeparturePicker.open()">
        <mat-label>{{'DRIVE_IN_BOOKING.START_DATE' | transloco }}</mat-label>
        <input matInput [min]="minDepartureDate" [matDatepicker]="simpleDeparturePicker"
          formControlName="simpleDepartureDate" (dateChange)="onSimpleDepartureDateChange($event)">
        <mat-datepicker-toggle matSuffix [for]="simpleDeparturePicker"></mat-datepicker-toggle>
        <mat-datepicker touchUi #simpleDeparturePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{'DRIVE_IN_BOOKING.START_TIME' | transloco }}</mat-label>
        <input matInput formControlName="simpleDepartureTime" [matAutocomplete]="simpleDepartureTimeAuto">
        <mat-autocomplete #simpleDepartureTimeAuto="matAutocomplete">
          @for (time of filteredDepartureTimeOptions | async; track time) {
          <mat-option [value]="time">
            {{time}}
          </mat-option>
          }
        </mat-autocomplete>
        <mat-icon matSuffix>schedule</mat-icon>
      </mat-form-field>
    </div>
    }
    <!-- Full Booking Options -->
    @if (!showSimpleBooking) {
    <div>
      <!-- Departure Type Selection -->
      @if (checkHotelOptions()) {
      <mat-radio-group formControlName="departureType" class="mb-3" (change)="onDepartureTypeChange($event.value)">
        <mat-radio-button value="flight" class="mr-4">Flight</mat-radio-button>
        <mat-radio-button value="hotel">Hotel</mat-radio-button>
      </mat-radio-group>
      }
      <!-- Flight Fields -->
      @if (bookingForm.get('departureType')?.value === 'flight') {
      <mat-form-field appearance="outline" (click)="picker.open()">
        <mat-label>{{ 'FORM.DEPARTURE_DATE' | transloco }}</mat-label>
        <input matInput [min]="minDepartureDate" [matDatepicker]="picker" formControlName="flightDepartureDate"
          (dateChange)="getFlightsByDate($event, 'departure'); onFlightDepartureDateChange($event)">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker touchUi #picker></mat-datepicker>
        @if (!bookingForm.controls.flightDepartureDate.valid &&
        bookingForm.controls.flightDepartureDate.touched) {
        <mat-error>
          {{ 'ERROR.DEPARTURE_FLIGHTNUMBER' | transloco }}
        </mat-error>
        }
      </mat-form-field>
      }
      @if (bookingForm.get('departureType')?.value === 'flight') {
      <mat-form-field appearance="outline">
        @if (isLoadingDeparture) {
        <mat-label>{{ 'FORM.FETCH_FLIGHTS' | transloco }}</mat-label>
        }
        @if (!isLoadingDeparture) {
        <mat-label>{{ 'FORM.FLIGHT_NUMBER' | transloco }}</mat-label>
        }
        <input matInput type="text" placeholder="{{ 'PLACEHOLDER.SEARCH_FLIGHT' | transloco }}" aria-label="Number"
          formControlName="flightDepartureNumber" [matAutocomplete]="autoDepartures"
          (input)="onDepartureNumberChange($event.target.value)">
        <mat-autocomplete #autoDepartures="matAutocomplete">
          @for (departFlight of filteredOptionsFlightsDepartures | async; track departFlight) {
          <mat-option [value]="departFlight.flightId" (onSelectionChange)="onDepartureSelect($event)"
            [disabled]="departFlight.locationAndStatus?.flightLegStatus === 'DEL' || departFlight.locationAndStatus?.flightLegStatus === 'Deleted'">
            <div class="display-flex"
              [ngClass]="{'text-decoration-line-through': departFlight.locationAndStatus?.flightLegStatus === 'DEL' || departFlight.locationAndStatus?.flightLegStatus === 'Deleted'}">
              <span class="font-weight-bold mr-2">
                {{departFlight.flightId}}
              </span>
              @if (translate.getActiveLang() === 'sv') {
              <span class="font-weight-light">{{departFlight.arrivalAirportSwedish}}</span>
              }
              @if (translate.getActiveLang() === 'en') {
              <span class="font-weight-light">{{departFlight.arrivalAirportEnglish}}</span>
              }
              <div class="spacer mr-2"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                {{departFlight.departureTime.scheduled | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          }
        </mat-autocomplete>
        @if (isLoadingDeparture) {
        <mat-spinner matSuffix color="accent" diameter="20">
        </mat-spinner>
        }
        @if (!isLoadingDeparture) {
        <mat-icon matSuffix>flight_takeoff</mat-icon>
        }
        @if (!bookingForm.controls.flightDepartureNumber.valid && bookingForm.controls.flightDepartureNumber.touched) {
        <mat-error>
          {{ 'ERROR.DEPARTURE_FLIGHTNUMBER' | transloco }}
        </mat-error>
        }
      </mat-form-field>
      }
      @if (bookingForm.get('departureType')?.value === 'flight' && selectedFlight==null) {
      <span class="mat-error">
        {{ 'ERROR.DEPARTURE_FLIGHTNUMBER' | transloco }}
      </span>
      }
      @if (bookingForm.get('departureType')?.value === 'flight') {
      <mat-form-field appearance="outline">
        <mat-label>{{ 'FORM.ARRIVAL_TIME' | transloco }}</mat-label>
        <mat-select (selectionChange)="getParkingTime($event)" formControlName="parkingfrom"
          [disabled]="selectedFlight==null">
          <mat-option [value]="this.arriveAtParking270Min">
            <div class="display-flex">
              <span class="mr-2">
                {{ 'PLACEHOLDER.4.5_HOURS_BEFORE' | transloco }}
              </span>
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                {{this.arriveAtParking270Min | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          <mat-option [value]="this.arriveAtParking255Min">
            <div class="display-flex">
              <span class="mr-2">
                {{ 'PLACEHOLDER.4.25_HOURS_BEFORE' | transloco }}
              </span>
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                {{this.arriveAtParking255Min | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          <mat-option [value]="this.arriveAtParking240Min">
            <div class="display-flex">
              <span class="mr-2">
                {{ 'PLACEHOLDER.4_HOURS_BEFORE' | transloco }}
              </span>
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                {{this.arriveAtParking240Min | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          <mat-option [value]="this.arriveAtParking225Min">
            <div class="display-flex">
              <span class="mr-2">
                {{ 'PLACEHOLDER.3.75_HOURS_BEFORE' | transloco }}
              </span>
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                {{this.arriveAtParking225Min | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          <mat-option [value]="this.arriveAtParking210Min">
            <div class="display-flex">
              <span class="mr-2">
                {{ 'PLACEHOLDER.3.5_HOURS_BEFORE' | transloco }}
              </span>
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                {{this.arriveAtParking210Min | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          <mat-option [value]="this.arriveAtParking195Min">
            <div class="display-flex">
              <span class="mr-2">
                {{ 'PLACEHOLDER.3.25_HOURS_BEFORE' | transloco }}
              </span>
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                {{this.arriveAtParking195Min | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          <mat-option [value]="this.arriveAtParking180Min">
            <div class="display-flex">
              <span class="mr-2">
                {{ 'PLACEHOLDER.3_HOURS_BEFORE' | transloco }}
              </span>
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                {{this.arriveAtParking180Min | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          <mat-option [value]="this.arriveAtParking165Min">
            <div class="display-flex">
              <span class="mr-2">
                {{ 'PLACEHOLDER.2.75_HOURS_BEFORE' | transloco }}
              </span>
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                {{this.arriveAtParking165Min | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          <mat-option [value]="this.arriveAtParking150Min">
            <div class="display-flex">
              <span class="mr-2">
                {{ 'PLACEHOLDER.2.5_HOURS_BEFORE' | transloco }}
              </span>
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                {{this.arriveAtParking150Min | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          <mat-option [value]="this.arriveAtParking135Min">
            <div class="display-flex">
              <span class="mr-2">
                {{ 'PLACEHOLDER.2.25_HOURS_BEFORE' | transloco }}
              </span>
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                {{this.arriveAtParking135Min | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          <mat-option [value]="this.arriveAtParking120Min">
            <div class="display-flex">
              <span class="mr-2">
                {{ 'PLACEHOLDER.2_HOURS_BEFORE' | transloco }}
              </span>
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                {{this.arriveAtParking120Min | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          <mat-option [value]="this.arriveAtParking105Min">
            <div class="display-flex">
              <span class="mr-2">
                {{ 'PLACEHOLDER.1.75_HOUR_BEFORE' | transloco }}
              </span>
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                {{this.arriveAtParking105Min | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          <mat-option [value]="this.arriveAtParking90Min">
            <div class="display-flex">
              <span class="mr-2">
                {{ 'PLACEHOLDER.1.5_HOUR_BEFORE' | transloco }}
              </span>
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                {{this.arriveAtParking90Min | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          <mat-option [value]="this.arriveAtParking75Min">
            <div class="display-flex">
              <span class="mr-2">
                {{ 'PLACEHOLDER.1.25_HOUR_BEFORE' | transloco }}
              </span>
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                {{this.arriveAtParking75Min | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          <mat-option [value]="this.arriveAtParking60Min">
            <div class="display-flex">
              <span class="mr-2">
                {{ 'PLACEHOLDER.1_HOUR_BEFORE' | transloco }}
              </span>
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                {{this.arriveAtParking60Min | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
        </mat-select>
        <mat-icon matSuffix>schedule</mat-icon>
        @if (!bookingForm.controls.parkingfrom.valid &&
        bookingForm.controls.parkingfrom.touched) {
        <mat-error>
          {{ 'ERROR.SELECT_PARKING_FROM' | transloco }}
        </mat-error>
        }
      </mat-form-field>
      }
      <!-- Hotel Fields -->
      @if (bookingForm.get('departureType')?.value === 'hotel') {
      <div>
        <mat-form-field appearance="outline" (click)="hotelDeparturePicker.open()">
          <mat-label>{{'INTERNAL_BOOKING.DEPARTURE_DATE' | transloco }}</mat-label>
          <input matInput [min]="minDepartureDate" [matDatepicker]="hotelDeparturePicker"
            formControlName="hotelDepartureDate" (dateChange)="onHotelDepartureDateChange($event)">
          <mat-datepicker-toggle matSuffix [for]="hotelDeparturePicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #hotelDeparturePicker></mat-datepicker>
          @if (!bookingForm.controls.hotelDepartureDate.valid && bookingForm.controls.hotelDepartureDate.touched) {
          <mat-error>
            {{'INTERNAL_BOOKING.PLEASE_SELECT_DATE' | transloco }}
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{'INTERNAL_BOOKING.DEPARTURE_TIME' | transloco }}</mat-label>
          <input matInput formControlName="hotelDepartureTime" [matAutocomplete]="hotelDepartureTimeAuto">
          <mat-autocomplete #hotelDepartureTimeAuto="matAutocomplete">
            @for (time of filteredHotelDepartureTimeOptions | async; track time) {
            <mat-option [value]="time">
              {{time}}
            </mat-option>
            }
          </mat-autocomplete>
          <mat-icon matSuffix>schedule</mat-icon>
          @if (!bookingForm.controls.hotelDepartureTime.valid && bookingForm.controls.hotelDepartureTime.touched) {
          <mat-error>
            {{'INTERNAL_BOOKING.PLEASE_SELECT_TIME' | transloco }}
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{'INTERNAL_BOOKING.SELECT_HOTEL' | transloco }}</mat-label>
          <mat-select formControlName="departureHotel">
            @for (hotel of hotelOptions; track hotel) {
            <mat-option [value]="hotel.value">
              {{hotel.viewValue}}
            </mat-option>
            }
          </mat-select>
          <mat-icon matSuffix>hotel</mat-icon>
          @if (!bookingForm.controls.departureHotel.valid && bookingForm.controls.departureHotel.touched) {
          <mat-error>
            {{'INTERNAL_BOOKING.PLEASE_SELECT_HOTEL' | transloco }}
          </mat-error>
          }
        </mat-form-field>
      </div>
      }
    </div>
    }
    <!-- Arrival -->
    @if (!bookingForm.get('subscription')?.value) {
    <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
      @if(showSimpleBooking){
      <mat-icon class="mr-3">directions_car</mat-icon>{{ 'PARKIFLY.SIMPLE_SEARCH_SELECT.ARRIVAL_HEADING' |
      transloco }}
      }@else{
      <mat-icon class="mr-3">flight_land</mat-icon>{{ 'PLACEHOLDER.ARRIVAL' | transloco }}
      }
    </mat-toolbar>
    }
    <!-- Simple Booking: Date and Time Only -->
    @if (showSimpleBooking && !bookingForm.get('subscription')?.value) {
    <div>
      <mat-form-field appearance="outline" (click)="simpleArrivalPicker.open()">
        <mat-label>{{'DRIVE_IN_BOOKING.END_DATE' | transloco }}</mat-label>
        <input matInput [min]="minSimpleArrivalDate" [matDatepicker]="simpleArrivalPicker"
          formControlName="simpleArrivalDate">
        <mat-datepicker-toggle matSuffix [for]="simpleArrivalPicker"></mat-datepicker-toggle>
        <mat-datepicker touchUi #simpleArrivalPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{'DRIVE_IN_BOOKING.END_TIME' | transloco }}</mat-label>
        <input matInput formControlName="simpleArrivalTime" [matAutocomplete]="simpleArrivalTimeAuto">
        <mat-autocomplete #simpleArrivalTimeAuto="matAutocomplete">
          @for (time of filteredArrivalTimeOptions | async; track time) {
          <mat-option [value]="time">
            {{time}}
          </mat-option>
          }
        </mat-autocomplete>
        <mat-icon matSuffix>schedule</mat-icon>
      </mat-form-field>
    </div>
    }
    <!-- Full Booking Options -->
    @if (!showSimpleBooking && !selectSubscription) {
    <div>
      <!-- Arrival Type Selection -->
      @if (checkHotelOptions()) {
      <mat-radio-group formControlName="arrivalType" class="mb-3" (change)="onArrivalTypeChange($event.value)">
        <mat-radio-button value="flight" class="mr-4">Flight</mat-radio-button>
        <mat-radio-button value="hotel">Hotel</mat-radio-button>
      </mat-radio-group>
      }
      <!-- Flight Fields -->
      @if (bookingForm.get('arrivalType')?.value === 'flight') {
      <div>
        <mat-form-field appearance="outline" (click)="picker1.open()">
          <mat-label>{{ 'FORM.ARRIVAL_DATE' | transloco }}</mat-label>
          <input matInput [min]="minArrivalDate" [matDatepicker]="picker1" formControlName="flightArrivalDate"
            (dateChange)="getFlightsByDate($event, 'arrival'); onFlightArrivalDateChange($event)">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker touchUi #picker1></mat-datepicker>
          @if (!bookingForm.controls.flightArrivalDate.valid && bookingForm.controls.flightArrivalDate.touched) {
          <mat-error>
            {{ 'ERROR.DATE' | transloco }}
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          @if (isLoadingArrival) {
          <mat-label>{{ 'FORM.FETCH_FLIGHTS' | transloco }}</mat-label>
          }
          @if (!isLoadingArrival) {
          <mat-label>{{ 'FORM.ARRIVAL_FLIGHTNUMBER' | transloco }}</mat-label>
          }
          <input matInput type="text" placeholder="{{ 'PLACEHOLDER.SEARCH_FLIGHT' | transloco }}" aria-label="Number"
            formControlName="flightArrivalNumber" [matAutocomplete]="autoArrivals" (input)="  ($event.target.value)">
          <mat-autocomplete #autoArrivals="matAutocomplete" [displayWith]="displayArrivalFlightWrapper()">
            @for (arrivalFlight of filteredOptionsFlightsArrivals | async; track arrivalFlight) {
            <mat-option [value]="arrivalFlight" (onSelectionChange)="onArrivalSelect($event)"
              [disabled]="arrivalFlight.locationAndStatus?.flightLegStatus === 'DEL' || arrivalFlight.locationAndStatus?.flightLegStatus === 'Deleted'">
              <div class="display-flex"
                [ngClass]="{'text-decoration-line-through': arrivalFlight.locationAndStatus?.flightLegStatus === 'DEL' || arrivalFlight.locationAndStatus?.flightLegStatus === 'Deleted'}">
                <span class="font-weight-bold mr-2">
                  {{arrivalFlight.flightId}}
                </span>
                @if (translate.getActiveLang() === 'sv') {
                <span class="font-weight-light">{{arrivalFlight.departureAirportSwedish}}</span>
                }
                @if (translate.getActiveLang() === 'en') {
                <span class="font-weight-light">{{arrivalFlight.departureAirportEnglish}}</span>
                }
                <div class="spacer mr-2"></div>
                <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) }}
                  {{arrivalFlight.arrivalTime.scheduled | date: 'HH:mm'}}
                </span>
              </div>
            </mat-option>
            }
          </mat-autocomplete>
          @if (isLoadingArrival) {
          <mat-spinner matSuffix color="accent" diameter="20">
          </mat-spinner>
          }
          @if (!isLoadingArrival) {
          <mat-icon matSuffix>flight_land</mat-icon>
          }
        </mat-form-field>
        @if ((bookingForm.controls.flightArrivalNumber.dirty || bookingForm.controls.flightArrivalNumber.touched) &&
        bookingForm.controls.flightArrivalId.invalid && bookingForm.controls.flightArrivalId.errors.required) {
        <span class="mat-error">
          {{ 'ERROR.ARRIVAL_FLIGHTNUMBER' | transloco }}
        </span>
        }
      </div>
      }
      <!-- Hotel Fields -->
      @if (bookingForm.get('arrivalType')?.value === 'hotel') {
      <div>
        <mat-form-field appearance="outline" (click)="hotelArrivalPicker.open()">
          <mat-label>{{'INTERNAL_BOOKING.ARRIVAL_DATE' | transloco }}</mat-label>
          <input matInput [min]="minHotelArrivalDate" [matDatepicker]="hotelArrivalPicker"
            formControlName="hotelArrivalDate">
          <mat-datepicker-toggle matSuffix [for]="hotelArrivalPicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #hotelArrivalPicker></mat-datepicker>
          @if (!bookingForm.controls.hotelArrivalDate.valid && bookingForm.controls.hotelArrivalDate.touched) {
          <mat-error>
            {{'INTERNAL_BOOKING.PLEASE_SELECT_DATE' | transloco }}
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{'INTERNAL_BOOKING.ARRIVAL_TIME' | transloco }}</mat-label>
          <input matInput formControlName="hotelArrivalTime" [matAutocomplete]="hotelArrivalTimeAuto">
          <mat-autocomplete #hotelArrivalTimeAuto="matAutocomplete">
            @for (time of filteredHotelArrivalTimeOptions | async; track time) {
            <mat-option [value]="time">
              {{time}}
            </mat-option>
            }
          </mat-autocomplete>
          <mat-icon matSuffix>schedule</mat-icon>
          @if (!bookingForm.controls.hotelArrivalTime.valid && bookingForm.controls.hotelArrivalTime.touched) {
          <mat-error>
            {{'INTERNAL_BOOKING.PLEASE_SELECT_DATE' | transloco }}
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{'INTERNAL_BOOKING.SELECT_HOTEL' | transloco }}</mat-label>
          <mat-select formControlName="arrivalHotel">
            @for (hotel of hotelOptions; track hotel) {
            <mat-option [value]="hotel.value">
              {{hotel.viewValue}}
            </mat-option>
            }
          </mat-select>
          <mat-icon matSuffix>hotel</mat-icon>
          @if (!bookingForm.controls.arrivalHotel.valid && bookingForm.controls.arrivalHotel.touched) {
          <mat-error>
            {{'INTERNAL_BOOKING.PLEASE_SELECT_DATE' | transloco }}
          </mat-error>
          }
        </mat-form-field>
      </div>
      }
    </div>
    }
    <!-- Parkings -->
    @if (bookingForm.get('organization')?.value?.name?.toLowerCase() !== 'ving') {
    <div>
      <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
        <mat-icon class="mr-3">local_parking</mat-icon>{{ 'INTERNAL_BOOKING.PARKINGS' | transloco }}
      </mat-toolbar>
      <mat-form-field appearance="outline" (click)="fetchParkings()">
        @if (!isLoadingParkings) {
        <mat-label>{{'INTERNAL_BOOKING.CHOOSE_PARKING' | transloco}}</mat-label>
        }
        @if (isLoadingParkings) {
        <mat-label>{{'INTERNAL_BOOKING.FETCHING_PARKINGS' | transloco}}</mat-label>
        }
        <mat-select (selectionChange)="selectParking($event)" formControlName="parking">
          <mat-select-trigger>
            {{bookingForm.get('parking')?.value?.name}}
          </mat-select-trigger>
          @for (item of parkings; track item) {
          <mat-option class="parking-option" [value]="item" class="width-100">
            <div class="flex-space-between">
              <span class="font-weight-bold mr-2">
                {{item?.name}}
              </span>
              <span class="font-weight-light">
                {{item?.availableParkingSpots}} {{'INTERNAL_BOOKING.SPOTS_AVAILABLE' | transloco}},
                {{item?.totalPrice}} SEK
              </span>
            </div>
          </mat-option>
          }
        </mat-select>
        @if (!isLoadingParkings) {
        <mat-icon matSuffix>local_parking</mat-icon>
        }
        @if (isLoadingParkings) {
        <mat-spinner matSuffix color="accent" diameter="20">
        </mat-spinner>
        }
        @if (bookingForm.controls.parking.hasError('timeout')) {
        <mat-error>{{ 'INTERNAL_BOOKING.CLICK_REFRESH'
          |
          transloco
          }}</mat-error>
        }
        @if (!bookingForm.controls.parking.hasError('timeout') && !bookingForm.controls.parking.valid &&
        bookingForm.controls.parking.touched) {
        <mat-error>
          {{'INTERNAL_BOOKING.PLEASE_SELECT_PARKING' | transloco }}
        </mat-error>
        }
      </mat-form-field>
    </div>
    }
    <!-- Parkings -->
    <!-- Additional services -->
    <!-- <div *ngIf="(bookingForm.get('organization')?.value?.name?.toLowerCase() == 'flygets.se')">
      <mat-toolbar *ngIf="additionalServices?.length > 0" class="my-4 mat-elevation-z8" color="primary">
        <mat-icon class="mr-3">shopping_cart</mat-icon>{{ 'INTERNAL_BOOKING.ADDITIONAL_SERVICES' | transloco }}
      </mat-toolbar>
      <mat-form-field *ngIf="additionalServices?.length > 0" appearance="outline">
        <mat-label class="margin-left-5">{{ 'INTERNAL_BOOKING.SELECT_ADDITIONAL_SERVICES' | transloco
        }}</mat-label>
        <mat-select multiple formControlName="additionalServices" [compareWith]="compareServices">
          <mat-option *ngFor="let item of additionalServices" [value]="item">
            <mat-pseudo-checkbox class="mr-2" [state]="isSelected(item) ? 'checked' : 'unchecked'"
              class="margin-right-8px">
            </mat-pseudo-checkbox>
            {{ item.name[locale] }}
          </mat-option>
        </mat-select>
        <mat-icon matSuffix>shopping_cart</mat-icon>
      </mat-form-field>
    </div> -->
    @if (!hasAvailableParking) {
    <mat-toolbar color="accent" class="mb-4 mat-elevation-z8 animate__animated animate__bounce">
      Inga lediga platser lediga för vald period
    </mat-toolbar>
    }
    <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
      <mat-icon class="mr-3">directions_car</mat-icon>{{ 'FORM.CAR_PERSON' | transloco }}
    </mat-toolbar>
    @if (organization?.name?.toLowerCase() == 'quality hotel arlanda xpo parkering') {
    <mat-form-field appearance="outline">
      <mat-label>{{ 'INTERNAL_BOOKING.BOOKING_NUMBER' | transloco }}</mat-label>
      <input matInput placeholder="{{ 'INTERNAL_BOOKING.ENTER_BOOKING_NUMBER' | transloco }}"
        oninput="this.value = this.value.trim().toUpperCase()" formControlName="bookingNumber"
        [disabled]="!isPassengersSelected">
      <mat-icon matSuffix>confirmation_number</mat-icon>
    </mat-form-field>
    }
    <mat-form-field appearance="outline">
      <mat-label>{{ 'FORM.CARID' | transloco }}</mat-label>
      <input matInput placeholder="{{ 'PLACEHOLDER.CARID' | transloco }}" [minlength]="4" [maxlength]="9"
        oninput="this.value = this.value.toUpperCase().replace(/\s+/g, '')" formControlName="carid">
      <mat-icon matSuffix>directions_car</mat-icon>
      @if (!bookingForm.controls.carid.valid &&
      bookingForm.controls.carid.touched) {
      <mat-error>
        {{ 'ERROR.CARID' | transloco }}
      </mat-error>
      }
    </mat-form-field>
    <app-text-input [formControl]='bookingForm.controls["firstname"]'
      [label]="isBookingNumberRequired() ? ('INTERNAL_BOOKING.BOOKING_NUMBER' | transloco) : ('FORM.FIRST_NAME' | transloco)"
      [placeholder]="isBookingNumberRequired() ? ('INTERNAL_BOOKING.ENTER_BOOKING_NUMBER' | transloco) : ('PLACEHOLDER.FIRST_NAME' | transloco)"
      [icon]="isBookingNumberRequired() ? 'confirmation_number' : 'account_box'">
    </app-text-input>
    <app-text-input [formControl]='bookingForm.controls["lastname"]' [label]="'FORM.LAST_NAME' | transloco"
      [placeholder]="'PLACEHOLDER.LAST_NAME' | transloco" [icon]="'account_box'">
    </app-text-input>
    <app-text-input [formControl]='bookingForm.controls["cellular"]' [type]="'tel'"
      [label]="'FORM.PHONENUMBER' | transloco" [placeholder]="'PLACEHOLDER.PHONENUMBER' | transloco"
      [icon]="'smartphone'">
    </app-text-input>
    <app-select-input [formControl]='bookingForm.controls["persons"]' [label]="'FORM.PERSONS' | transloco"
      [icon]="'people'" [items]="persons">
    </app-select-input>
    @if (!showSimpleBooking) {
    <div class="block-mt-5-mb-75">
      <mat-checkbox formControlName="onlyHandBaggage" (change)="checkBaggage($event)">
        <span class="font-weight-light">{{ 'FORM.ONLY_HANDBAGGAGE' | transloco }}</span>
      </mat-checkbox>
    </div>
    }
    @if (selectedParking?.overbooking && (organization?.name?.toLowerCase() == 'quality hotel arlanda xpo parkering' ||
    organization?.name?.toLowerCase() == 'flygets.se' || organization?.name?.toLowerCase() == 'ving') &&
    selectedParking?.availableParkingSpots <= 0) { <div class="block-mb-75">
      <mat-checkbox formControlName="overrideParking" (change)="checkOverrideParking($event)">
        <span class="font-weight-light">{{ 'PLACEHOLDER.OVER_BOOKING' | transloco }}</span>
      </mat-checkbox>
</div>
}
<div class="block-width-100-mb-75">
  @if(organization?.name?.toLowerCase() !== 'ving'){
  <mat-checkbox formControlName="continueBookingWithPrice" [disabled]="!isBookingFormValid()"
    (change)="checkContinueBookingWithPrice($event)">
    <span class="font-weight-light">{{ 'INTERNAL_BOOKING.CONTINUE_BOOKING_WITH_PRICE' | transloco }}</span>
  </mat-checkbox>
  }
  <div class="margin-left-32px-top-6px">
    @if (!bookingForm.get('continueBookingWithPrice')?.value) {
    <div class="text-95rem-500-475569">
      <span>{{ 'INTERNAL_BOOKING.TOTAL_AMOUNT' | transloco }}: {{ calculatedPrice }} SEK</span>
    </div>
    }

    @if (bookingForm.get('continueBookingWithPrice')?.value) {
    <div class="margin-top-6px">
      <div class="text-95rem-600-1e293b-mb-75">
        <span>{{ 'INTERNAL_BOOKING.TOTAL_AMOUNT' | transloco }}: {{ calculatedPrice }} SEK</span>
      </div>
      <mat-form-field appearance="outline" class="width-100-max-250">
        <mat-label>{{ 'INTERNAL_BOOKING.DESIRED_PRICE' | transloco }}</mat-label>
        <input matInput type="number" formControlName="customPrice" [placeholder]="calculatedPrice.toString()">
        <span matSuffix class="margin-right-8px-font-500">SEK</span>
      </mat-form-field>
    </div>
    }
  </div>
</div>
</form>
<div class="flex-space-between-mt-1-3rem">
  <button mat-raised-button color="warn" type="button" class="mt-2" (click)="resetForm()" class="width-10">{{
    'FORM.CLEAR' |
    transloco | uppercase}}
  </button>
  <button mat-raised-button type="button" class="success-button my-2 mt-2 width-max-content"
    (click)="openBottomSheet()">
    @if (isLoading) {
    <mat-icon class="cursor-pointer">
      <mat-spinner color="accent" diameter="20">
      </mat-spinner>
    </mat-icon>
    }{{ 'FORM.CONTINUE' | transloco | uppercase}}
  </button>
</div>
<app-small-footer></app-small-footer>
</div>
}